<script setup lang="ts">
import { ref, computed } from "vue";
import { useVModel } from "@vueuse/core";
import functions from "addeus-common-library/stores/function";

type DownloadFileType = {
    filePath: string;
    open: boolean;
    block: string;
};

const props = defineProps<DownloadFileType>();
const emit = defineEmits(["update:open"]);
const isModalOpen = useVModel(props, "open", emit);
const email = ref("");
const isFetching = ref(false);

const hasEmail = computed(() => {
    return (
        email.value.length > 0 &&
        email.value.match(/^[a-zA-Z0-9._%+-]+\@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/i) !== null
    );
});

async function download() {
    isFetching.value = true;

    try {
        await functions.sendEmailContact({
            email: email.value,
            block: props.block,
        });

        window.open(
            `${window.location.protocol}//${window.location.host}/${props.filePath}`,
        );
        isModalOpen.value = false;
    } catch {}
    isFetching.value = false;
}
</script>


<template>
    <VModal :open="isModalOpen" size="medium" @close="isModalOpen = false">
        <template #content>
            <VFlex
                flex-direction="column"
                row-gap="1rem"
                align-items="center"
                class="mb-6">
                <div class="is-uppercase is-size-4 is-weight-700 mt-4 has-text-primary">
                    <Translate path=".title"></Translate>
                </div>
                <p
                    class="copy-block has-text-white is-size-6 has-text-dark has-text-centered">
                    <Translate path=".content"></Translate>
                </p>
                <form class="w-100 px-6">
                    <VField>
                        <VControl icon="perm_identity">
                            <VInput
                                v-model="email"
                                placeholder=".email"
                                class="input"
                                type="text"
                                autocomplete="username" />
                        </VControl>
                    </VField>
                    <vButton
                        class="button is-secondary mt-4 w-100"
                        size="huge"
                        :disabled="!hasEmail"
                        :loading="isFetching"
                        @click="download()">
                        <Translate path=".download"></Translate>
                    </vButton>
                </form>
            </VFlex>
        </template>
        <template #title>&nbsp;</template>
        <template #action></template>
    </VModal>
</template>

<style lang="scss">
.v-modal {
    input {
        height: 50px !important;
    }

    .w-100 {
        width: 100%;
    }

    button > span {
        width: 100%;
    }

    .form-icon {
        padding-top: 10px;
    }

    > .modal-background {
        border: 0;
    }

    > .modal-content {
        > .modal-card {
            > .modal-card-head {
                border-bottom: 0;
            }

            > .modal-card-body {
                padding-top: 0;

                > .inner-content {
                    > div {
                        > .copy-block {
                            max-width: 450px;
                        }
                    }
                }
            }
        }
    }
}
</style>
